const LoadingIcon = () => {
    return <img src="assets/images/loading.gif" height="20px" width="20px" />;
};

export default LoadingIcon;
